import type { ActionHandler } from '../types'

export const handleBiographyEntry: ActionHandler<'BIOGRAPHY_ENTRY'> = async (ctx, payload) => {
  const row = {
    character_id: ctx.characterId,
    event_label: payload.event_label,
    character_age: payload.character_age,
    game_year: payload.game_year ?? null,
    flavour_text: payload.flavour_text ?? null,
    is_gm_only: payload.is_gm_only ?? false,
    effects_applied: {},
    sequence: 0,
  }

  const { data, error } = await ctx.supabase
    .from('character_biography')
    .insert(row)
    .select()
    .single()

  if (error) throw error

  return {
    effects: [{
      character_id: ctx.characterId,
      target_table: 'character_biography',
      target_row_id: data.id,
      target_field: '*',
      operation: 'INSERT' as const,
      old_value: null,
      new_value: data,
    }],
    label: `Biography: ${payload.event_label}`,
  }
}
